import { render } from "./TopSlideSheet.vue?vue&type=template&id=0a5b5820&scoped=true"
import script from "./TopSlideSheet.vue?vue&type=script&lang=js"
export * from "./TopSlideSheet.vue?vue&type=script&lang=js"

import "./TopSlideSheet.vue?vue&type=style&index=0&id=0a5b5820&lang=scss&scoped=true"

import exportComponent from "/root/Fnedu/build/build20250805.141732/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a5b5820"]])

export default __exports__